import { useMutation } from '@apollo/client';

import { useCurrentEventQuery } from '../../event/hooks/useCurrentEventQuery';
import { useToast } from '../../toast/Toast.context';
import {
  STAFF_DELETE_CARPOOL_TRIP,
  StaffDeleteCarpoolTripMutation,
  StaffDeleteCarpoolTripMutationVariables,
} from '../graphql/mutation/staffDeleteCarpoolTripMutation.graphql';
import {
  CARPOOL_TRIPS,
  CarpoolTripsQueryVariables,
} from '../graphql/query/carpoolTripsQuery.graphql';

export const useStaffDeleteCarpoolTripMutation = () => {
  const { data: currentEventData } = useCurrentEventQuery();
  const { showToast } = useToast();
  const [mutate] = useMutation<
    StaffDeleteCarpoolTripMutation,
    StaffDeleteCarpoolTripMutationVariables
  >(STAFF_DELETE_CARPOOL_TRIP);

  const staffDeleteCarpoolTrip = async (tripId: string) => {
    const eventId = currentEventData?.currentEvent?.id;
    if (!eventId) {
      return;
    }

    await mutate({
      variables: { tripId },
      refetchQueries: [
        {
          query: CARPOOL_TRIPS,
          variables: { eventId } satisfies CarpoolTripsQueryVariables,
        },
      ],
    });

    showToast({
      type: 'success',
      message: 'Trajet supprimé.',
    });
  };

  return { staffDeleteCarpoolTrip };
};
